import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { Roles } from '@scenario/enums/roles.enum';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DefaultRedirectGuard implements CanActivate {
    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly router: Router
    ) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.rolesLoaded$.pipe(
            take(1),
            map(() => {
                const connectedUser = this.authenticationService.connectedUser.getValue();
                const roles = connectedUser?.roles ?? [];

                const hasScenarioAccess = roles.includes(Roles.USER) || roles.includes(Roles.ADMIN);
                const hasPriceCardAccess = roles.includes(Roles.PC_USER) || roles.includes(Roles.PC_ADMIN);

                if (hasScenarioAccess) {
                    this.router.navigateByUrl('/finder');
                } else if (hasPriceCardAccess) {
                    this.router.navigateByUrl('/price-card');
                } else {
                    this.router.navigateByUrl('/info');
                }

                return false;
            }),
        );
    }
}
